// SignaturePad — podpis zákazníka prstom (canvas). Zdieľaný komponent (ústava: systémovo, nie lokálne).
// Vyňaté z PoterProtokolView 2026-07-08 (Mirko: rovnaký podpis aj v obhliadke). onChange dostáva dataURL PNG alebo ''.
import React, { useRef } from 'react'
import { COLORS } from '../theme.js'

export default function SignaturePad({ onChange }) {
  const ref = useRef(null)
  const drawing = useRef(false)
  const pos = (e) => {
    const c = ref.current, r = c.getBoundingClientRect()
    const t = e.touches ? e.touches[0] : e
    return { x: (t.clientX - r.left) * (c.width / r.width), y: (t.clientY - r.top) * (c.height / r.height) }
  }
  const start = (e) => { e.preventDefault(); drawing.current = true; const ctx = ref.current.getContext('2d'); const p = pos(e); ctx.beginPath(); ctx.moveTo(p.x, p.y) }
  const move = (e) => { if (!drawing.current) return; e.preventDefault(); const ctx = ref.current.getContext('2d'); const p = pos(e); ctx.lineTo(p.x, p.y); ctx.lineWidth = 2.2; ctx.lineCap = 'round'; ctx.strokeStyle = '#1a1a1a'; ctx.stroke() }
  const end = () => { if (!drawing.current) return; drawing.current = false; onChange(ref.current.toDataURL('image/png')) }
  const clear = () => { const c = ref.current; c.getContext('2d').clearRect(0, 0, c.width, c.height); onChange('') }
  return (
    <div>
      <canvas ref={ref} width={600} height={200}
        style={{ width: '100%', height: 120, border: `1px solid ${COLORS.line}`, borderRadius: 10, touchAction: 'none', background: '#fff' }}
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end} />
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 4 }}>
        <span style={{ fontSize: 11, color: COLORS.muted }}>Podpíš prstom</span>
        <button onClick={clear} style={{ fontSize: 12, color: COLORS.brand, background: 'none', border: 'none', cursor: 'pointer' }}>✕ Vyčistiť</button>
      </div>
    </div>
  )
}
